module.exports = __webpack_public_path__ + "media/empty-states/error-2x-b1b822e1.png";